import {useProductFromParams} from "hooks/useProductFromParams";
import {useEffect} from "react";
import {useNavigate, useLocation} from "react-router-dom";

import {useAuth} from "./useAuth";

import {USER_ROLES} from "data/user";
import {isPartnerLike} from "utils/roles";

export function useCheckPermissions({disabled = false} = {}) {
  const {role, isLoading} = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const product = useProductFromParams();

  useEffect(() => {
    if (disabled) return;
    if (isLoading || location.pathname === "/" || location.pathname === "/login") {
      return;
    }

    const pathParts = location.pathname.split("/").filter(Boolean);

    if (pathParts[0] === "scene") {
      return;
    }

    if (isPartnerLike(role) && product.value !== "JB") {
      navigate("/", {replace: true});
      return;
    }
  }, [disabled, location.pathname, role, navigate, isLoading, product]);
}
